/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AppDomainVoucherSchemasBulkOperationResponse,
  ArchiveVoucher200,
  BodyUploadVoucherImage,
  ExportMonthlyRedemptionsParams,
  HTTPValidationError,
  ImageUploadResponse,
  ListVouchersParams,
  PaginatedResponseVoucherResponse,
  PublishVoucher200,
  RedeemedVouchersMonthlyStats,
  VoucherCodeGenerateRequest,
  VoucherCodeGenerateResponse,
  VoucherCodeImportRequest,
  VoucherCodeResponse,
  VoucherCreate,
  VoucherResponse,
  VoucherUpdate
} from '../model';

import { apiInstance } from '../../lib/apiInstance';




/**
 * Create a new voucher (Admin only)
 * @summary Create Voucher
 */
export const createVoucher = (
    voucherCreate: VoucherCreate,
 signal?: AbortSignal
) => {


      return apiInstance<VoucherResponse>(
      {url: `/api/vouchers/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: voucherCreate, signal
    },
      );
    }



export const getCreateVoucherMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVoucher>>, TError,{data: VoucherCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVoucher>>, TError,{data: VoucherCreate}, TContext> => {

const mutationKey = ['createVoucher'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVoucher>>, {data: VoucherCreate}> = (props) => {
          const {data} = props ?? {};

          return  createVoucher(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVoucherMutationResult = NonNullable<Awaited<ReturnType<typeof createVoucher>>>
    export type CreateVoucherMutationBody = VoucherCreate
    export type CreateVoucherMutationError = HTTPValidationError

    /**
 * @summary Create Voucher
 */
export const useCreateVoucher = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVoucher>>, TError,{data: VoucherCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVoucher>>,
        TError,
        {data: VoucherCreate},
        TContext
      > => {
      return useMutation(getCreateVoucherMutationOptions(options), queryClient);
    }
    /**
 * List vouchers with filtering and pagination
 * @summary List Vouchers
 */
export const listVouchers = (
    params?: ListVouchersParams,
 signal?: AbortSignal
) => {


      return apiInstance<PaginatedResponseVoucherResponse>(
      {url: `/api/vouchers/`, method: 'GET',
        params, signal
    },
      );
    }




export const getListVouchersQueryKey = (params?: ListVouchersParams,) => {
    return [
    `/api/vouchers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVouchersQueryOptions = <TData = Awaited<ReturnType<typeof listVouchers>>, TError = HTTPValidationError>(params?: ListVouchersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVouchers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVouchersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVouchers>>> = ({ signal }) => listVouchers(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVouchers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListVouchersQueryResult = NonNullable<Awaited<ReturnType<typeof listVouchers>>>
export type ListVouchersQueryError = HTTPValidationError


export function useListVouchers<TData = Awaited<ReturnType<typeof listVouchers>>, TError = HTTPValidationError>(
 params: undefined |  ListVouchersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVouchers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVouchers>>,
          TError,
          Awaited<ReturnType<typeof listVouchers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVouchers<TData = Awaited<ReturnType<typeof listVouchers>>, TError = HTTPValidationError>(
 params?: ListVouchersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVouchers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVouchers>>,
          TError,
          Awaited<ReturnType<typeof listVouchers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVouchers<TData = Awaited<ReturnType<typeof listVouchers>>, TError = HTTPValidationError>(
 params?: ListVouchersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVouchers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Vouchers
 */

export function useListVouchers<TData = Awaited<ReturnType<typeof listVouchers>>, TError = HTTPValidationError>(
 params?: ListVouchersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVouchers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListVouchersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Upload Voucher Image
 */
export const uploadVoucherImage = (
    bodyUploadVoucherImage: BodyUploadVoucherImage,
 signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`file`, bodyUploadVoucherImage.file);

      return apiInstance<ImageUploadResponse>(
      {url: `/api/vouchers/images/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }



export const getUploadVoucherImageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadVoucherImage>>, TError,{data: BodyUploadVoucherImage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof uploadVoucherImage>>, TError,{data: BodyUploadVoucherImage}, TContext> => {

const mutationKey = ['uploadVoucherImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadVoucherImage>>, {data: BodyUploadVoucherImage}> = (props) => {
          const {data} = props ?? {};

          return  uploadVoucherImage(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadVoucherImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadVoucherImage>>>
    export type UploadVoucherImageMutationBody = BodyUploadVoucherImage
    export type UploadVoucherImageMutationError = HTTPValidationError

    /**
 * @summary Upload Voucher Image
 */
export const useUploadVoucherImage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadVoucherImage>>, TError,{data: BodyUploadVoucherImage}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadVoucherImage>>,
        TError,
        {data: BodyUploadVoucherImage},
        TContext
      > => {
      return useMutation(getUploadVoucherImageMutationOptions(options), queryClient);
    }
    /**
 * Get a specific voucher
 * @summary Get Voucher
 */
export const getVoucher = (
    voucherId: string,
 signal?: AbortSignal
) => {


      return apiInstance<VoucherResponse>(
      {url: `/api/vouchers/${voucherId}`, method: 'GET', signal
    },
      );
    }




export const getGetVoucherQueryKey = (voucherId: string,) => {
    return [
    `/api/vouchers/${voucherId}`
    ] as const;
    }


export const getGetVoucherQueryOptions = <TData = Awaited<ReturnType<typeof getVoucher>>, TError = HTTPValidationError>(voucherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVoucher>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVoucherQueryKey(voucherId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVoucher>>> = ({ signal }) => getVoucher(voucherId, signal);





   return  { queryKey, queryFn, enabled: !!(voucherId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVoucher>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVoucherQueryResult = NonNullable<Awaited<ReturnType<typeof getVoucher>>>
export type GetVoucherQueryError = HTTPValidationError


export function useGetVoucher<TData = Awaited<ReturnType<typeof getVoucher>>, TError = HTTPValidationError>(
 voucherId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVoucher>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVoucher>>,
          TError,
          Awaited<ReturnType<typeof getVoucher>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVoucher<TData = Awaited<ReturnType<typeof getVoucher>>, TError = HTTPValidationError>(
 voucherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVoucher>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVoucher>>,
          TError,
          Awaited<ReturnType<typeof getVoucher>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVoucher<TData = Awaited<ReturnType<typeof getVoucher>>, TError = HTTPValidationError>(
 voucherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVoucher>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Voucher
 */

export function useGetVoucher<TData = Awaited<ReturnType<typeof getVoucher>>, TError = HTTPValidationError>(
 voucherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVoucher>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVoucherQueryOptions(voucherId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Update a voucher (Admin only)
 * @summary Update Voucher
 */
export const updateVoucher = (
    voucherId: string,
    voucherUpdate: VoucherUpdate,
 signal?: AbortSignal
) => {


      return apiInstance<VoucherResponse>(
      {url: `/api/vouchers/${voucherId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: voucherUpdate, signal
    },
      );
    }



export const getUpdateVoucherMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVoucher>>, TError,{voucherId: string;data: VoucherUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVoucher>>, TError,{voucherId: string;data: VoucherUpdate}, TContext> => {

const mutationKey = ['updateVoucher'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVoucher>>, {voucherId: string;data: VoucherUpdate}> = (props) => {
          const {voucherId,data} = props ?? {};

          return  updateVoucher(voucherId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVoucherMutationResult = NonNullable<Awaited<ReturnType<typeof updateVoucher>>>
    export type UpdateVoucherMutationBody = VoucherUpdate
    export type UpdateVoucherMutationError = HTTPValidationError

    /**
 * @summary Update Voucher
 */
export const useUpdateVoucher = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVoucher>>, TError,{voucherId: string;data: VoucherUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVoucher>>,
        TError,
        {voucherId: string;data: VoucherUpdate},
        TContext
      > => {
      return useMutation(getUpdateVoucherMutationOptions(options), queryClient);
    }
    /**
 * Publish a draft voucher (Admin only)
 * @summary Publish Voucher
 */
export const publishVoucher = (
    voucherId: string,
 signal?: AbortSignal
) => {


      return apiInstance<PublishVoucher200>(
      {url: `/api/vouchers/${voucherId}/publish`, method: 'POST', signal
    },
      );
    }



export const getPublishVoucherMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishVoucher>>, TError,{voucherId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof publishVoucher>>, TError,{voucherId: string}, TContext> => {

const mutationKey = ['publishVoucher'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishVoucher>>, {voucherId: string}> = (props) => {
          const {voucherId} = props ?? {};

          return  publishVoucher(voucherId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishVoucherMutationResult = NonNullable<Awaited<ReturnType<typeof publishVoucher>>>

    export type PublishVoucherMutationError = HTTPValidationError

    /**
 * @summary Publish Voucher
 */
export const usePublishVoucher = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishVoucher>>, TError,{voucherId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publishVoucher>>,
        TError,
        {voucherId: string},
        TContext
      > => {
      return useMutation(getPublishVoucherMutationOptions(options), queryClient);
    }
    /**
 * Archive a voucher (Admin only)
 * @summary Archive Voucher
 */
export const archiveVoucher = (
    voucherId: string,
 signal?: AbortSignal
) => {


      return apiInstance<ArchiveVoucher200>(
      {url: `/api/vouchers/${voucherId}/archive`, method: 'POST', signal
    },
      );
    }



export const getArchiveVoucherMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveVoucher>>, TError,{voucherId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveVoucher>>, TError,{voucherId: string}, TContext> => {

const mutationKey = ['archiveVoucher'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveVoucher>>, {voucherId: string}> = (props) => {
          const {voucherId} = props ?? {};

          return  archiveVoucher(voucherId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveVoucherMutationResult = NonNullable<Awaited<ReturnType<typeof archiveVoucher>>>

    export type ArchiveVoucherMutationError = HTTPValidationError

    /**
 * @summary Archive Voucher
 */
export const useArchiveVoucher = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveVoucher>>, TError,{voucherId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveVoucher>>,
        TError,
        {voucherId: string},
        TContext
      > => {
      return useMutation(getArchiveVoucherMutationOptions(options), queryClient);
    }
    /**
 * Generate additional voucher codes for a voucher (Admin only)
 * @summary Generate Voucher Codes
 */
export const generateVoucherCodes = (
    voucherId: string,
    voucherCodeGenerateRequest: VoucherCodeGenerateRequest,
 signal?: AbortSignal
) => {


      return apiInstance<VoucherCodeGenerateResponse>(
      {url: `/api/vouchers/${voucherId}/codes/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: voucherCodeGenerateRequest, signal
    },
      );
    }



export const getGenerateVoucherCodesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateVoucherCodes>>, TError,{voucherId: string;data: VoucherCodeGenerateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof generateVoucherCodes>>, TError,{voucherId: string;data: VoucherCodeGenerateRequest}, TContext> => {

const mutationKey = ['generateVoucherCodes'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateVoucherCodes>>, {voucherId: string;data: VoucherCodeGenerateRequest}> = (props) => {
          const {voucherId,data} = props ?? {};

          return  generateVoucherCodes(voucherId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateVoucherCodesMutationResult = NonNullable<Awaited<ReturnType<typeof generateVoucherCodes>>>
    export type GenerateVoucherCodesMutationBody = VoucherCodeGenerateRequest
    export type GenerateVoucherCodesMutationError = HTTPValidationError

    /**
 * @summary Generate Voucher Codes
 */
export const useGenerateVoucherCodes = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateVoucherCodes>>, TError,{voucherId: string;data: VoucherCodeGenerateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateVoucherCodes>>,
        TError,
        {voucherId: string;data: VoucherCodeGenerateRequest},
        TContext
      > => {
      return useMutation(getGenerateVoucherCodesMutationOptions(options), queryClient);
    }
    /**
 * Export all voucher codes as CSV (Admin only)
 * @summary Export Voucher Codes
 */
export const exportVoucherCodes = (
    voucherId: string,
 signal?: AbortSignal
) => {


      return apiInstance<void>(
      {url: `/api/vouchers/${voucherId}/codes/export`, method: 'GET', signal
    },
      );
    }




export const getExportVoucherCodesQueryKey = (voucherId: string,) => {
    return [
    `/api/vouchers/${voucherId}/codes/export`
    ] as const;
    }


export const getExportVoucherCodesQueryOptions = <TData = Awaited<ReturnType<typeof exportVoucherCodes>>, TError = HTTPValidationError>(voucherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportVoucherCodes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportVoucherCodesQueryKey(voucherId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportVoucherCodes>>> = ({ signal }) => exportVoucherCodes(voucherId, signal);





   return  { queryKey, queryFn, enabled: !!(voucherId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportVoucherCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportVoucherCodesQueryResult = NonNullable<Awaited<ReturnType<typeof exportVoucherCodes>>>
export type ExportVoucherCodesQueryError = HTTPValidationError


export function useExportVoucherCodes<TData = Awaited<ReturnType<typeof exportVoucherCodes>>, TError = HTTPValidationError>(
 voucherId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportVoucherCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportVoucherCodes>>,
          TError,
          Awaited<ReturnType<typeof exportVoucherCodes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportVoucherCodes<TData = Awaited<ReturnType<typeof exportVoucherCodes>>, TError = HTTPValidationError>(
 voucherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportVoucherCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportVoucherCodes>>,
          TError,
          Awaited<ReturnType<typeof exportVoucherCodes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportVoucherCodes<TData = Awaited<ReturnType<typeof exportVoucherCodes>>, TError = HTTPValidationError>(
 voucherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportVoucherCodes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export Voucher Codes
 */

export function useExportVoucherCodes<TData = Awaited<ReturnType<typeof exportVoucherCodes>>, TError = HTTPValidationError>(
 voucherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportVoucherCodes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportVoucherCodesQueryOptions(voucherId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * @summary Import Voucher Codes
 */
export const importVoucherCodes = (
    voucherId: string,
    voucherCodeImportRequest: VoucherCodeImportRequest,
 signal?: AbortSignal
) => {


      return apiInstance<AppDomainVoucherSchemasBulkOperationResponse>(
      {url: `/api/vouchers/${voucherId}/codes/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: voucherCodeImportRequest, signal
    },
      );
    }



export const getImportVoucherCodesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importVoucherCodes>>, TError,{voucherId: string;data: VoucherCodeImportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof importVoucherCodes>>, TError,{voucherId: string;data: VoucherCodeImportRequest}, TContext> => {

const mutationKey = ['importVoucherCodes'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importVoucherCodes>>, {voucherId: string;data: VoucherCodeImportRequest}> = (props) => {
          const {voucherId,data} = props ?? {};

          return  importVoucherCodes(voucherId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportVoucherCodesMutationResult = NonNullable<Awaited<ReturnType<typeof importVoucherCodes>>>
    export type ImportVoucherCodesMutationBody = VoucherCodeImportRequest
    export type ImportVoucherCodesMutationError = HTTPValidationError

    /**
 * @summary Import Voucher Codes
 */
export const useImportVoucherCodes = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importVoucherCodes>>, TError,{voucherId: string;data: VoucherCodeImportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importVoucherCodes>>,
        TError,
        {voucherId: string;data: VoucherCodeImportRequest},
        TContext
      > => {
      return useMutation(getImportVoucherCodesMutationOptions(options), queryClient);
    }
    /**
 * Export monthly voucher activations and redemptions grouped by voucher (Admin only).
 * @summary Export Monthly Redemptions
 */
export const exportMonthlyRedemptions = (
    params: ExportMonthlyRedemptionsParams,
 signal?: AbortSignal
) => {


      return apiInstance<Blob>(
      {url: `/api/vouchers/exports/redemptions`, method: 'GET',
        params, signal
    },
      );
    }




export const getExportMonthlyRedemptionsQueryKey = (params?: ExportMonthlyRedemptionsParams,) => {
    return [
    `/api/vouchers/exports/redemptions`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportMonthlyRedemptionsQueryOptions = <TData = Awaited<ReturnType<typeof exportMonthlyRedemptions>>, TError = HTTPValidationError>(params: ExportMonthlyRedemptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportMonthlyRedemptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportMonthlyRedemptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportMonthlyRedemptions>>> = ({ signal }) => exportMonthlyRedemptions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportMonthlyRedemptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportMonthlyRedemptionsQueryResult = NonNullable<Awaited<ReturnType<typeof exportMonthlyRedemptions>>>
export type ExportMonthlyRedemptionsQueryError = HTTPValidationError


export function useExportMonthlyRedemptions<TData = Awaited<ReturnType<typeof exportMonthlyRedemptions>>, TError = HTTPValidationError>(
 params: ExportMonthlyRedemptionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportMonthlyRedemptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportMonthlyRedemptions>>,
          TError,
          Awaited<ReturnType<typeof exportMonthlyRedemptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportMonthlyRedemptions<TData = Awaited<ReturnType<typeof exportMonthlyRedemptions>>, TError = HTTPValidationError>(
 params: ExportMonthlyRedemptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportMonthlyRedemptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportMonthlyRedemptions>>,
          TError,
          Awaited<ReturnType<typeof exportMonthlyRedemptions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportMonthlyRedemptions<TData = Awaited<ReturnType<typeof exportMonthlyRedemptions>>, TError = HTTPValidationError>(
 params: ExportMonthlyRedemptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportMonthlyRedemptions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export Monthly Redemptions
 */

export function useExportMonthlyRedemptions<TData = Awaited<ReturnType<typeof exportMonthlyRedemptions>>, TError = HTTPValidationError>(
 params: ExportMonthlyRedemptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportMonthlyRedemptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportMonthlyRedemptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get statistics for redeemed vouchers: current month count and percentage difference from last month (Admin only)
 * @summary Get Redeemed Vouchers Monthly Stats
 */
export const getRedeemedVouchersMonthlyStats = (

 signal?: AbortSignal
) => {


      return apiInstance<RedeemedVouchersMonthlyStats>(
      {url: `/api/vouchers/statistics/redeemed-vouchers-monthly`, method: 'GET', signal
    },
      );
    }




export const getGetRedeemedVouchersMonthlyStatsQueryKey = () => {
    return [
    `/api/vouchers/statistics/redeemed-vouchers-monthly`
    ] as const;
    }


export const getGetRedeemedVouchersMonthlyStatsQueryOptions = <TData = Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRedeemedVouchersMonthlyStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>> = ({ signal }) => getRedeemedVouchersMonthlyStats(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRedeemedVouchersMonthlyStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>>
export type GetRedeemedVouchersMonthlyStatsQueryError = unknown


export function useGetRedeemedVouchersMonthlyStats<TData = Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>,
          TError,
          Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRedeemedVouchersMonthlyStats<TData = Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>,
          TError,
          Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRedeemedVouchersMonthlyStats<TData = Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Redeemed Vouchers Monthly Stats
 */

export function useGetRedeemedVouchersMonthlyStats<TData = Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRedeemedVouchersMonthlyStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRedeemedVouchersMonthlyStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Directly activate a voucher for the current user by assigning a code.
 * @summary Activate Voucher
 */
export const activateVoucher = (
    voucherId: string,
 signal?: AbortSignal
) => {


      return apiInstance<VoucherCodeResponse>(
      {url: `/api/vouchers/${voucherId}/activate`, method: 'POST', signal
    },
      );
    }



export const getActivateVoucherMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateVoucher>>, TError,{voucherId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activateVoucher>>, TError,{voucherId: string}, TContext> => {

const mutationKey = ['activateVoucher'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateVoucher>>, {voucherId: string}> = (props) => {
          const {voucherId} = props ?? {};

          return  activateVoucher(voucherId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateVoucherMutationResult = NonNullable<Awaited<ReturnType<typeof activateVoucher>>>

    export type ActivateVoucherMutationError = HTTPValidationError

    /**
 * @summary Activate Voucher
 */
export const useActivateVoucher = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateVoucher>>, TError,{voucherId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateVoucher>>,
        TError,
        {voucherId: string},
        TContext
      > => {
      return useMutation(getActivateVoucherMutationOptions(options), queryClient);
    }
